<template>
	<div>
		<nav class="navbar checkout-bar center-elements">
			<div id="notify" :class="{ open: showErrorMsg }">
				<div class="notify-text">
					{{ errorMsg }}
					<img
						class="close-btn"
						src="/images/close.png"
						@click="closeError"
					/>
				</div>
			</div>
			<div class="container">
				<div class="input-group">
					<span class="input-group-btn">
						<button
							type="button"
							class="button button-transparent"
							:disabled="currentItem.quantity == 0"
							data-type="minus"
							data-field="quant[1]"
							@click="updateQuantity(-1)"
						>
							<span
								class="sk-icon-minus"
								data-cy="item-modal-qty-decrement"
							></span>
						</button>
					</span>
					<input
						type="text"
						name="quant[1]"
						class="form-control input-number qty-form"
						readonly
						:value="currentItem.quantity"
						min="1"
						max="10"
						data-cy="item-modal-qty"
					/>
					<span class="input-group-btn">
						<button
							type="button"
							class="button button-transparent"
							:disabled="currentItem.quantity == 10"
							data-type="plus"
							data-field="quant[1]"
							@click="updateQuantity(1)"
						>
							<span
								class="sk-icon-plus"
								data-cy="item-modal-qty-increment"
							></span>
						</button>
					</span>
				</div>
				<button
					type="button"
					:disabled="addToCartDisabled"
					class="button button-primary button-footer"
					data-cy="add-to-cart"
					@click="addToCart"
				>
					{{ confirmationText }}: {{ currentItemPrice | currency }}
				</button>
			</div>
		</nav>
	</div>
</template>

<style scoped>
.notify-text {
	color: #fff;
	padding: 8px;
	font-size: 14px;
}

#notify {
	width: 100%;
	background: var(--gR-teal-70);
	color: var(--gR-white);
	text-align: center;
	display: block;
	z-index: 0;
	position: absolute;
	bottom: 0;
	transition: all 0.2s cubic-bezier(0.4, 0, 1, 1);
	z-index: 1;
}

#notify.open {
	transform: translateY(-67px);
}

.container {
	padding: 0;
}

.input-group {
	display: flex;
	align-items: center;
	width: 94px;
	max-width: 120px;
	margin-right: 20px;
}

.input-group-btn {
	font-size: 15px;
}

.qty-form {
	text-align: center;
	border: none !important;
	padding: 0;
	font-size: 18px;
	font-weight: 700;
}

.qty-form:read-only {
	background: var(--gR-white);
}

.qty-plus,
.qty-minus {
	font-size: 22px;
}

.container,
.panel {
	z-index: 5;
}

@media (max-width: 500px) {
	.navbar {
		position: fixed;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 1030;
	}
}

@media only screen and (min-width: 290px) and (max-width: 349px) {
	.input-group {
		max-width: 110px !important;
		margin-right: 10px !important;
		margin-bottom: 0px !important;
	}
}
</style>

<script>
import utils from "@/utils"
import currencyFilterMixin from "@/mixins/currency-filter-mixin"
import { MenuType } from "@reef-os/utils/enums/menuType"

export default {
	name: "ItemFooter",
	mixins: [currencyFilterMixin],
	props: {
		inStockMetas: Array
	},
	computed: {
		addToCartDisabled() {
			return this.$route.meta.preview == true
		},
		currentItem() {
			return this.$store.state.currentItem
		},
		currentItemPrice() {
			return this.$store.getters.currentItemPrice
		},
		cart() {
			return this.$store.state.cart
		},
		confirmationText() {
			let text = "Add to Cart"
			if (this.$route.query && this.$route.query.editing) {
				text = "Update"
			}
			return text
		}
	},
	data: function () {
		return {
			errorMsg: null,
			showErrorMsg: false
		}
	},
	methods: {
		closeError: function () {
			this.showErrorMsg = false
		},
		async addToCart() {
			const invalidMetaId = this.detectInvalidMeta()
			if (!invalidMetaId) {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Add to Cart",
					data: {
						id: this.$store.state.currentItem.id
					}
				})

				const itemsInCartCount = this.$store.getters.itemsInCartCount
				if (itemsInCartCount > 0) {
					const cartMenuType = this.$store.getters.cartMenuType
					const excludedMenuTypes = [MenuType.ESSENTIALS]
					const isMixedCartAllowed =
						excludedMenuTypes.includes(
							this.currentItem.menu_type
						) || excludedMenuTypes.includes(cartMenuType)
					if (
						cartMenuType != this.currentItem.menu_type &&
						!isMixedCartAllowed
					) {
						let promise = utils.createPromise()
						this.$emit("confirmClear", promise)
						const confirmed = await promise.promise
						if (confirmed) {
							this.$store.dispatch("clearCart")
						} else {
							return
						}
					}
				}

				this.$store.dispatch("addToCart")
				this.$emit("addedToCart")
			} else {
				this.$emit("invalidMeta", invalidMetaId)
				this.errorMsg = "Please fill in all options"
				this.showErrorMsg = true
				setTimeout(() => {
					this.showErrorMsg = false
				}, 3000)
			}
		},
		updateQuantity(value) {
			this.$store.dispatch(
				"updateCurrentItemQuantity",
				this.currentItem.quantity + value
			)
		},
		detectInvalidMeta() {
			if (!this.inStockMetas || this.inStockMetas.length == 0) {
				return null
			}
			if (this.inStockMetas.length > 0) {
				const requiredMetas = this.inStockMetas.filter(
					(meta) => meta.required == 1
				)
				if (requiredMetas && requiredMetas.length > 0) {
					if (
						this.$store.state.currentItem.options == null ||
						this.$store.state.currentItem.options == undefined
					) {
						return requiredMetas[0].id
					} else {
						for (var i = 0; i < requiredMetas.length; i++) {
							const reqMeta = requiredMetas[i]
							const keysArr = Object.keys(
								this.$store.state.currentItem.options
							)
							const reqOptions = keysArr.filter(
								(metaOption) => metaOption == reqMeta.key
							)
							if (reqOptions.length == 0) {
								return reqMeta.id
							}
						}
					}
				}
			}
		}
	}
}
</script>